// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__1kxKI","selects":"Documents_selects__3ESWw"};